export const TABLE_EXPAND_ROW = 'TABLE_EXPAND_ROW';
export const TABLE_HIDE_ROW = 'TABLE_HIDE_ROW';
export const TABLE_SELECT_ROW = 'TABLE_SELECT_ROW';

/**
 * Toggle expandable row state
 *
 * @param {string} stateKey Reducers state key
 * @param {object} rowIndex Value of the primary column to toggle
 * @param {boolean} [keepOthers] TRUE to keep opened other rows
 * @returns {{}} Action
 */
export function expandRow(stateKey, rowIndex, keepOthers) {
    return {
        type: TABLE_EXPAND_ROW,
        stateKey,
        rowIndex,
        keepOthers
    };
}

/**
 *
 * @param stateKey
 * @param rowIndex
 * @param keepOthers
 * @returns {{type: string, stateKey: *, rowIndex: *, keepOthers: *}}
 */
export function hideRow(stateKey, rowIndex, keepOthers) {
    return {
        type: TABLE_HIDE_ROW,
        stateKey,
        rowIndex,
        keepOthers
    };
}



// WEBPACK FOOTER //
// ./src/js/actions/expandableRow.js